/**
 * Gets a value from url
 * @param {string} name The key of the value to reterive
 * @param {string} url Url path to parse
 */
exports.getValueFromHref = (name, url = "") => {
	if (!url) {
		url = window.location.href;
	}
	name = name.replace(/[[\]]/g, "\\$&");
	const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
		results = regex.exec(url);
	if (!results) {
		return "";
	}
	if (!results[2]) {
		return "";
	}
	return decodeURIComponent(results[2].replace(/\+/g, " "));
};
